<template>
    <div name="review" class="review">
        <span class="r-title">후기로 만나는<br/>솔닥 고객 만족도</span>
        <div class="review1">
            <img class="review1-image" v-if="review1" src="../../assets/renew_mobile/r_1_inactive.png" />
            <img class="review1-image" v-else src="../../assets/renew_mobile/r_1_active.png" />
            <div class="review-btn" v-if="review1" @click="review1Click">
                더보기
                <img class="arrow" src="../../assets/renew_mobile/right_arrow.png" />
            </div>
            <img class="review-close-btn" v-else @click="review1Close" 
                src="../../assets/renew_mobile/close_btn.png"
            />
            <span class="rm-title">
                진료부터 약 처방까지,<br/>정말 간편해요
            </span>
            <span class="rm1-contents">
                카톡에서 진료 예약부터 결제, 진료 내역까지<br/>
                한 번에 확인할 수 있으니까 너무 좋네요.<br/>
                솔닥은 편리함이 남달라요.
            </span>
            <span class="rm1-sub-contents">
                2022년 6월 VoC 중
            </span>
        </div>
        <div class="review2">
            <img class="review1-image" v-if="review2" src="../../assets/renew_mobile/r_2_inactive.png" />
            <img class="review1-image" v-else src="../../assets/renew_mobile/r_2_active.png" />
            <div class="review-btn" v-if="review2" @click="review2Click">
                더보기
                <img class="arrow" src="../../assets/renew_mobile/right_arrow.png" />
            </div>
            <img class="review-close-btn" v-else @click="review2Close" 
                src="../../assets/renew_mobile/close_btn.png"
            />
            <span class="rm-title">
                이제 병원 때문에<br/>반차 쓰는 일은 없어요
            </span>
            <span class="rm2-contents">
                이전에는 병원 진료 시간을 맞추느라 주기적<br/>
                으로 반차를 써야 했었는데 이제는 잠깐만<br/>
                시간을 내 원격으로 진료 보고 있어요.
            </span>
            <span class="rm2-sub-contents">
                2022년 8월 VoC 중
            </span>
        </div>
        <div class="review3">
            <img class="review1-image" v-if="review3" src="../../assets/renew_mobile/r_3_inactive.png" />
            <img class="review1-image" v-else src="../../assets/renew_mobile/r_3_active.png" />
            <div class="review-btn" v-if="review3" @click="review3Click">
                더보기
                <img class="arrow" src="../../assets/renew_mobile/right_arrow.png" />
            </div>
            <img class="review-close-btn" v-else @click="review3Close" 
                src="../../assets/renew_mobile/close_btn.png"
            />
            <span class="rm-title">
                아이가 있어서<br/>
                더 유용하게<br/>
                쓰고 있어요
            </span>
            <span class="rm3-contents">
                아기랑 병원 가는 게 쉬운 일이 아니었는데,<br/>
                집에서 솔닥으로 해결 가능하니까 비교도<br/>
                안되게 수월해요. 솔닥이 있어 다행이에요.
            </span>
            <span class="rm3-sub-contents">
                2022년 9월 VoC 중
            </span>
        </div>
        <div class="review4">
            <img class="review1-image" v-if="review4" src="../../assets/renew_mobile/r_4_inactive.png" />
            <img class="review1-image" v-else src="../../assets/renew_mobile/r_4_active.png" />
            <div class="review-btn" v-if="review4" @click="review4Click">
                더보기
                <img class="arrow" src="../../assets/renew_mobile/right_arrow.png" />
            </div>
            <img class="review-close-btn" v-else @click="review4Close" 
                src="../../assets/renew_mobile/close_btn.png"
            />
            <span class="rm-title">
                주변에 소개하니<br/>다들 만족해요
            </span>
            <span class="rm4-contents">
                만성질환 때문에 병원 가느라 고생하는 게<br/>
                힘들어 보여서 추천했는데 직접 써본 친구들은<br/>
                모두 만족한다고 해서 제가 다 뿌듯해요.
            </span>
            <span class="rm4-sub-contents">
                2022년 11월 VoC 중
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name:'review',
    data: function()
    {
        return {
            review1: true,
            review2: true,
            review3: true,
            review4: true
        }
    },
    mounted: function()
    {
        let eheight = $('.introduction').outerHeight();

        $(window).scroll(function () {
            var height = $(document).scrollTop();
            let winHeight = $(window).height();
            if(height > (eheight * 2.5) + eheight && height < (eheight * 2.8) + eheight)
            {
                $('.r-title').css('display', `inline-block`);
            
            }
            else if(height >= (eheight * 2.9) + 700)
            {                
                $('.r-title').css('display', `inline-block`);
              
             
            }            
        })
    },
    methods: {
        review1Click: function()
        {
            this.review1 = false;
            $('.rm1-contents').css('display', `inline-block`);
            $('.rm1-sub-contents').css('display', `inline-block`);
        },
        review1Close: function()
        {
            this.review1 = true;
            $('.rm1-contents').css('display', `none`);
            $('.rm1-sub-contents').css('display', `none`);
        },
        review2Click: function()
        {
            this.review2 = false;
            $('.rm2-contents').css('display', `inline-block`);
            $('.rm2-sub-contents').css('display', `inline-block`);
        },
        review2Close: function()
        {
            this.review2 = true;
            $('.rm2-contents').css('display', `none`);
            $('.rm2-sub-contents').css('display', `none`);
        },
        review3Click: function()
        {
            this.review3 = false;
            $('.rm3-contents').css('display', `inline-block`);
            $('.rm3-sub-contents').css('display', `inline-block`);
        },
        review3Close: function()
        {
            this.review3 = true;
            $('.rm3-contents').css('display', `none`);
            $('.rm3-sub-contents').css('display', `none`);
        },
        review4Click: function()
        {
            this.review4 = false;
            $('.rm4-contents').css('display', `inline-block`);
            $('.rm4-sub-contents').css('display', `inline-block`);
        },
        review4Close: function()
        {
            this.review4 = true;
            $('.rm4-contents').css('display', `none`);
            $('.rm4-sub-contents').css('display', `none`);
        }
    }
}
</script>

<style scoped> 
    @media screen and (max-width: 360px){
        .review{
            width: 100%;
            height: 1457px;
            background: #F3F4F7;
            padding-top: 70px;
            padding-bottom: 63.53px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            position: relative;
        }

        .r-title {
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 600;
            font-size: 23px;
            line-height: 30px;
            text-align: center;
            color: #1A1A1A;
            /* display: none;
            animation: fadeInUp 1s; */
        }

        .review1{
            top: 164px;
            position: absolute;
            width: 236px;
            height: 286.47px;

        }
        .review2{
            top: 479px;
            position: absolute;
            width: 236px;
            height: 286.47px;

        }
        .review3{
            top: 793px;
            position: absolute;
            width: 236px;
            height: 286.47px;

        }
        .review4{
            top: 1107px;
            position: absolute;
            width: 236px;
            height: 286.47px;

        }
        .review1-image{
            position: absolute;
            z-index: 1;
            width: 236px;
            height: 286.47px;
        }
        .review-btn{
            position: absolute;
            bottom: 35px;
            left: 24px;
            z-index: 2;
            width: 68.21px;
            height: 27.28px;
            border: 1px solid #FFFFFF;
            border-radius: 6px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 13.63px;
            padding-right: 10.23px;
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 11px;
            line-height: 26px;
            color: #FFFFFF;
        }
        .arrow {
            width: 6.82px;
        }
        .review-close-btn{
            position: absolute;
            z-index: 2;
            cursor: pointer;
            top: 24px;
            right: 21px;
            width: 12px;
        }
        .rm-title{
            position: absolute;
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 600;
            font-size: 19px;
            line-height: 27px;
        /* or 136% */
            color: #FFFFFF;
            z-index: 2;
            top: 19px;
            left: 16px;
        }
        .rm1-contents{
            position: absolute;
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            /* or 162% */
            bottom: 58.47px;
            left: 16px;
            z-index: 2;
            color: #FFFFFF;
            display: none;
            animation: fadeInUp 1s;
        }
        .rm1-sub-contents{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 29px;             
            color: #CCCCCC;
            position: absolute;
            bottom: 24.47px;
            left: 16px;
            z-index: 2;
            display: none;
            animation: fadeInUp1 1s;
        }
        .rm2-contents{
            position: absolute;
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            /* or 162% */
            bottom: 58.47px;
            left: 16px;
            z-index: 2;
            color: #FFFFFF;
            display: none;
            animation: fadeInUp 1s;
        }
        .rm2-sub-contents{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 29px;             
            color: #CCCCCC;
            position: absolute;
            bottom: 24.47px;
            left: 16px;
            z-index: 2;
            display: none;
            animation: fadeInUp1 1s;
        }
        .rm3-contents{
            position: absolute;
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            /* or 162% */
            bottom: 58.47px;
            left: 16px;
            z-index: 2;
            color: #FFFFFF;
            display: none;
            animation: fadeInUp 1s;
        }
        .rm3-sub-contents{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 29px;             
            color: #CCCCCC;
            position: absolute;
            bottom: 24.47px;
            left: 16px;
            z-index: 2;
            display: none;
            animation: fadeInUp1 1s;
        }
        .rm4-contents{
            position: absolute;
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            /* or 162% */
            bottom: 58.47px;
            left: 16px;
            z-index: 2;
            color: #FFFFFF;
            display: none;
            animation: fadeInUp 1s;
        }
        .rm4-sub-contents{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 29px;             
            color: #CCCCCC;
            position: absolute;
            bottom: 24.47px;
            left: 16px;
            z-index: 2;
            display: none;
            animation: fadeInUp1 1s;
        }
    }
    @media screen and (min-width: 361px){
        .review{
            width: 100%;
            height: 2139px;
            background: #F3F4F7;
            padding-top: 89px;
            padding-bottom: 96px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            position: relative;
        }

        .r-title {
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 600;
            font-size: 32px;
            line-height: 44px;
            text-align: center;
            color: #1A1A1A;
            /* display: none;
            animation: fadeInUp 1s; */
        }

        .review1{
            top: 231px;
            position: absolute;
            width: 346px;
            height: 420px;

        }
        .review2{
            top: 695px;
            position: absolute;
            width: 346px;
            height: 420px;

        }
        .review3{
            top: 1159px;
            position: absolute;
            width: 346px;
            height: 420px;

        }
        .review4{
            top: 1623px;
            position: absolute;
            width: 346px;
            height: 420px;

        }
        .review1-image{
            position: absolute;
            z-index: 1;
        }
        .review-btn{
            position: absolute;
            bottom: 35px;
            left: 24px;
            z-index: 2;
            width: 100px;
            height: 40px;
            border: 1px solid #FFFFFF;
            border-radius: 6px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 20px;
            padding-right: 15px;
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 26px;
            color: #FFFFFF;
        }
        .review-close-btn{
            position: absolute;
            top: 35px;
            right: 24px;
            z-index: 2;
            cursor: pointer;
        }
        .rm-title{
            position: absolute;
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 600;
            font-size: 28px;
            line-height: 38px;
        /* or 136% */
            color: #FFFFFF;
            z-index: 2;
            top: 28px;
            left: 23px;
        }
        .rm1-contents{
            position: absolute;
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 26px;
            /* or 162% */
            bottom: 71px;
            left: 23px;
            z-index: 2;
            color: #FFFFFF;
            display: none;
            animation: fadeInUp 1s;
        }
        .rm1-sub-contents{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 29px;       
            color: #CCCCCC;
            position: absolute;
            bottom: 24px;
            left: 23px;
            z-index: 2;
            display: none;
            animation: fadeInUp1 1s;
        }
        .rm2-contents{
            position: absolute;
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 26px;
            /* or 162% */
            bottom: 71px;
            left: 23px;
            z-index: 2;
            color: #FFFFFF;
            display: none;
            animation: fadeInUp 1s;
        }
        .rm2-sub-contents{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 29px;       
            color: #CCCCCC;
            position: absolute;
            bottom: 24px;
            left: 23px;
            z-index: 2;
            display: none;
            animation: fadeInUp1 1s;
        }
        .rm3-contents{
            position: absolute;
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 26px;
            /* or 162% */
            bottom: 71px;
            left: 23px;
            z-index: 2;
            color: #FFFFFF;
            display: none;
            animation: fadeInUp 1s;
        }
        .rm3-sub-contents{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 29px;       
            color: #CCCCCC;
            position: absolute;
            bottom: 24px;
            left: 23px;
            z-index: 2;
            display: none;
            animation: fadeInUp1 1s;
        }
        .rm4-contents{
            position: absolute;
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 26px;
            /* or 162% */
            bottom: 71px;
            left: 23px;
            z-index: 2;
            color: #FFFFFF;
            display: none;
            animation: fadeInUp 1s;
        }
        .rm4-sub-contents{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 29px;       
            color: #CCCCCC;
            position: absolute;
            bottom: 24px;
            left: 23px;
            z-index: 2;
            display: none;
            animation: fadeInUp1 1s;
        }
    }

    
    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_main/Review.vue